<label class="switch-label">
    <div class="switch">
        <input type="checkbox" [checked]="checkStatus()" (change)="changeValue()" />
        <span class="slider"></span>
    </div>
</label>
